/** Sort keys sent to `GET /devices?sort=` — must match backend `_device_sort_key`. */
export const DEVICE_TABLE_SORT_KEYS = [
  "name",
  "uid",
  "tags",
  "status",
  "delay",
  "protocol",
  "sampling",
  "period",
  "install",
  "warranty",
  "calibration",
  "last_seen",
  "location",
  "region",
  "assigned",
  "assignees",
] as const;

export type DeviceTableSortKey = (typeof DEVICE_TABLE_SORT_KEYS)[number];

export type DeviceTableColumnDef = {
  id: string;
  label: string;
  sortKey?: DeviceTableSortKey;
  align?: "left" | "right" | "center";
};

export const DEVICE_TABLE_COLUMNS: DeviceTableColumnDef[] = [
  { id: "select", label: "", align: "center" },
  { id: "name", label: "Logger", sortKey: "name" },
  { id: "uid", label: "UID", sortKey: "uid" },
  { id: "tags", label: "Tags", sortKey: "tags" },
  { id: "status", label: "Health", sortKey: "status" },
  { id: "last_seen", label: "Last Seen", sortKey: "last_seen" },
  { id: "protocol", label: "Protocol", sortKey: "protocol" },
  { id: "sampling", label: "Sampling", sortKey: "sampling" },
  { id: "period", label: "Period", sortKey: "period" },
  { id: "install", label: "Install", sortKey: "install" },
  { id: "warranty", label: "Warranty", sortKey: "warranty" },
  { id: "calibration", label: "Calibration", sortKey: "calibration" },
  { id: "location", label: "Location", sortKey: "location" },
  { id: "region", label: "Region", sortKey: "region" },
  { id: "assigned", label: "Assigned", sortKey: "assigned" },
  { id: "assignees", label: "More", sortKey: "assignees" },
  { id: "actions", label: "Actions", align: "right" },
];

export const DEVICE_TABLE_DEFAULT_SORT_ORDER: Record<DeviceTableSortKey, "asc" | "desc"> = {
  name: "asc",
  uid: "asc",
  tags: "asc",
  status: "asc",
  delay: "asc",
  protocol: "asc",
  sampling: "asc",
  period: "asc",
  install: "desc",
  warranty: "desc",
  calibration: "desc",
  last_seen: "desc",
  location: "asc",
  region: "asc",
  assigned: "asc",
  assignees: "desc",
};

export function isDeviceTableSortKey(value: string): value is DeviceTableSortKey {
  return (DEVICE_TABLE_SORT_KEYS as readonly string[]).includes(value);
}
